import React, {
    useState,
    useEffect
} from "react";

import axios from "axios";

import "./UploadCenter.css";

import {
    FiUploadCloud,
    FiVideo,
    FiImage,
    FiCheckCircle,
    FiClock,
    FiXCircle,
    FiLock
} from "react-icons/fi";

import IgniteNavbar from "../../layout/IgniteNavbar";
import IgniteHeader from "../../layout/IgniteHeader";


const UploadCenter = () => {
 useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, []);
    /* ============================
        HIDE WEBSITE NAVBAR / FOOTER
    ============================ */

    useEffect(() => {

        const navbar =
            document.querySelector(
                "header, .navbar"
            );

        const footer =
            document.querySelector(
                "footer"
            );

        if (navbar) {
            navbar.style.display = "none";
        }

        if (footer) {
            footer.style.display = "none";
        }

        return () => {

            if (navbar) {
                navbar.style.display = "";
            }

            if (footer) {
                footer.style.display = "";
            }

        };

    }, []);


    /* ============================
        USER
    ============================ */

    const email =
        localStorage.getItem(
            "user_email"
        );


    /* ============================
        JOURNEY LEVEL
    ============================ */

    const [
        currentLevel,
        setCurrentLevel
    ] = useState(1);

    const [
        levelLoading,
        setLevelLoading
    ] = useState(true);


    /* ============================
        FETCH CURRENT LEVEL
    ============================ */

    const fetchLevel = async () => {

        if (!email) {

            setLevelLoading(false);

            return;

        }

        try {

            setLevelLoading(true);

            const res =
                await axios.get(
                    `/api/ignite/profile/${email}`
                );

            const level =
                Number(
                    res.data?.summary
                        ?.currentLevel
                ) || 1;

            setCurrentLevel(level);

        }

        catch (err) {

            console.error(
                "Ignite Level Error:",
                err
            );

            setCurrentLevel(1);

        }

        finally {

            setLevelLoading(false);

        }

    };


    useEffect(() => {

        fetchLevel();

    }, [email]);


    /* ============================
        LEVEL ACCESS
    ============================ */

    const hammerUnlocked =
        currentLevel >= 3;

    const storyUnlocked =
        currentLevel >= 3;

    const sleepUnlocked =
        currentLevel >= 4;


    /* ============================
        HAMMER
    ============================ */

    const [
        hammerFile,
        setHammerFile
    ] = useState(null);

    const [
        hammerPreview,
        setHammerPreview
    ] = useState("");

    const [
        hammerUploading,
        setHammerUploading
    ] = useState(false);

    const [
        hammerProgress,
        setHammerProgress
    ] = useState(0);


    /* ============================
        NON-DOMINANT HAMMER
    ============================ */

    const [
        nonDominantHammerFile,
        setNonDominantHammerFile
    ] = useState(null);

    const [
        nonDominantHammerPreview,
        setNonDominantHammerPreview
    ] = useState("");

    const [
        nonDominantHammerUploading,
        setNonDominantHammerUploading
    ] = useState(false);

    const [
        nonDominantHammerProgress,
        setNonDominantHammerProgress
    ] = useState(0);


    /* ============================
        STORY
    ============================ */

    const [
        storyFile,
        setStoryFile
    ] = useState(null);

    const [
        storyPreview,
        setStoryPreview
    ] = useState("");

    const [
        storyUploading,
        setStoryUploading
    ] = useState(false);

    const [
        storyProgress,
        setStoryProgress
    ] = useState(0);


    /* ============================
        SLEEP
    ============================ */

    const [
        sleepFile,
        setSleepFile
    ] = useState(null);

    const [
        sleepPreview,
        setSleepPreview
    ] = useState("");

    const [
        sleepUploading,
        setSleepUploading
    ] = useState(false);

    const [
        sleepProgress,
        setSleepProgress
    ] = useState(0);


    /* ============================
        STATUS
    ============================ */

    const [
        status,
        setStatus
    ] = useState({

        hammer: "pending",

        nonDominantHammer:
            "pending",

        story: "pending",

        sleep: "pending"

    });


    /* ============================
        REMARKS
    ============================ */

    const [
        remarks,
        setRemarks
    ] = useState({

        hammer: "",

        nonDominantHammer: "",

        story: "",

        sleep: ""

    });


    /* ============================
        SLEEP DAYS
    ============================ */

    const [
        sleepDays,
        setSleepDays
    ] = useState([]);


    /* ============================
        FILE SELECT
    ============================ */

    const chooseHammer = (e) => {

        const file =
            e.target.files?.[0];

        if (!file) return;

        setHammerFile(file);

        setHammerPreview(
            URL.createObjectURL(file)
        );

    };


    const chooseNonDominantHammer =
        (e) => {

            const file =
                e.target.files?.[0];

            if (!file) return;

            setNonDominantHammerFile(
                file
            );

            setNonDominantHammerPreview(
                URL.createObjectURL(file)
            );

        };


    const chooseStory = (e) => {

        const file =
            e.target.files?.[0];

        if (!file) return;

        setStoryFile(file);

        setStoryPreview(
            URL.createObjectURL(file)
        );

    };


    const chooseSleep = (e) => {

        const file =
            e.target.files?.[0];

        if (!file) return;

        setSleepFile(file);

        setSleepPreview(
            URL.createObjectURL(file)
        );

    };


    /* ============================
        HAMMER UPLOAD
    ============================ */

    const uploadHammer = async () => {

        if (!hammerUnlocked) {

            alert(
                "Hammer Challenge is locked. Complete Level 2 first."
            );

            return;

        }

        if (!hammerFile) {

            alert(
                "Choose Hammer Video"
            );

            return;

        }

        try {

            setHammerUploading(true);

            const formData =
                new FormData();

            formData.append(
                "email",
                email
            );

            formData.append(
                "hand",
                "dominant"
            );

            formData.append(
                "file",
                hammerFile
            );

            await axios.post(

                "/api/ignite/upload-hammer",

                formData,

                {

                    headers: {
                        "Content-Type":
                            "multipart/form-data"
                    },

                    onUploadProgress:
                        (event) => {

                            if (
                                event.total
                            ) {

                                setHammerProgress(

                                    Math.round(

                                        (
                                            event.loaded *
                                            100
                                        ) /
                                        event.total

                                    )

                                );

                            }

                        }

                }

            );

            setStatus(
                prev => ({
                    ...prev,
                    hammer:
                        "pending"
                })
            );

            alert(
                "Hammer Uploaded Successfully"
            );

            await fetchLevel();

        }

        catch (err) {

            alert(

                err.response
                    ?.data
                    ?.message ||

                "Upload Failed"

            );

        }

        finally {

            setHammerUploading(
                false
            );

            setHammerProgress(0);

        }

    };


    /* ============================
        NON-DOMINANT HAMMER
    ============================ */

    const uploadNonDominantHammer =
        async () => {

            if (!hammerUnlocked) {

                alert(
                    "Non-Dominant Hammer is locked. Complete Level 2 first."
                );

                return;

            }

            if (
                !nonDominantHammerFile
            ) {

                alert(
                    "Choose Non-Dominant Hammer Video"
                );

                return;

            }

            try {

                setNonDominantHammerUploading(
                    true
                );

                const formData =
                    new FormData();

                formData.append(
                    "email",
                    email
                );

                formData.append(
                    "hand",
                    "non_dominant"
                );

                formData.append(
                    "file",
                    nonDominantHammerFile
                );

                await axios.post(

                    "/api/ignite/upload-hammer",

                    formData,

                    {

                        headers: {

                            "Content-Type":
                                "multipart/form-data"

                        },

                        onUploadProgress:
                            (event) => {

                                if (
                                    event.total
                                ) {

                                    setNonDominantHammerProgress(

                                        Math.round(

                                            (
                                                event.loaded *
                                                100
                                            ) /
                                            event.total

                                        )

                                    );

                                }

                            }

                    }

                );

                setStatus(
                    prev => ({

                        ...prev,

                        nonDominantHammer:
                            "pending"

                    })
                );

                alert(
                    "Non-Dominant Hammer Uploaded Successfully"
                );

                await fetchLevel();

            }

            catch (err) {

                alert(

                    err.response
                        ?.data
                        ?.message ||

                    "Upload Failed"

                );

            }

            finally {

                setNonDominantHammerUploading(
                    false
                );

                setNonDominantHammerProgress(
                    0
                );

            }

        };


    /* ============================
        STORY UPLOAD
    ============================ */

    const uploadStory = async () => {

        if (!storyUnlocked) {

            alert(
                "Real Life Story is locked. Complete Level 2 first."
            );

            return;

        }

        if (!storyFile) {

            alert(
                "Choose Story Video"
            );

            return;

        }

        try {

            setStoryUploading(true);

            const formData =
                new FormData();

            formData.append(
                "email",
                email
            );

            formData.append(
                "file",
                storyFile
            );

            await axios.post(

                "/api/ignite/upload-story",

                formData,

                {

                    headers: {

                        "Content-Type":
                            "multipart/form-data"

                    },

                    onUploadProgress:
                        (event) => {

                            if (
                                event.total
                            ) {

                                setStoryProgress(

                                    Math.round(

                                        (
                                            event.loaded *
                                            100
                                        ) /
                                        event.total

                                    )

                                );

                            }

                        }

                }

            );

            setStatus(
                prev => ({

                    ...prev,

                    story: "pending"

                })
            );

            alert(
                "Story Uploaded Successfully"
            );

            await fetchLevel();

        }

        catch (err) {

            alert(

                err.response
                    ?.data
                    ?.message ||

                "Upload Failed"

            );

        }

        finally {

            setStoryUploading(
                false
            );

            setStoryProgress(0);

        }

    };


    /* ============================
        SLEEP UPLOAD
    ============================ */

    const uploadSleep = async () => {

        if (!sleepUnlocked) {

            alert(
                "Sleep Tracking is locked. Complete Level 3 first."
            );

            return;

        }

        if (!sleepFile) {

            alert(
                "Choose Screenshot"
            );

            return;

        }

        try {

            setSleepUploading(true);

            const formData =
                new FormData();

            formData.append(
                "email",
                email
            );

            formData.append(
                "file",
                sleepFile
            );

            await axios.post(

                "/api/ignite/upload-sleep",

                formData,

                {

                    headers: {

                        "Content-Type":
                            "multipart/form-data"

                    },

                    onUploadProgress:
                        (event) => {

                            if (
                                event.total
                            ) {

                                setSleepProgress(

                                    Math.round(

                                        (
                                            event.loaded *
                                            100
                                        ) /
                                        event.total

                                    )

                                );

                            }

                        }

                }

            );

            setStatus(
                prev => ({

                    ...prev,

                    sleep: "pending"

                })
            );

            alert(
                "Sleep Uploaded Successfully"
            );

            await fetchLevel();

        }

        catch (err) {

            alert(

                err.response
                    ?.data
                    ?.message ||

                "Upload Failed"

            );

        }

        finally {

            setSleepUploading(
                false
            );

            setSleepProgress(0);

        }

    };


    /* ============================
        STATUS DISPLAY
    ============================ */

    const renderStatus =
        (type) => {

            if (
                status[type] ===
                "approved"
            ) {

                return (

                    <>
                        <FiCheckCircle />
                        Approved
                    </>

                );

            }

            if (
                status[type] ===
                "rejected"
            ) {

                return (

                    <>
                        <FiXCircle />
                        Rejected
                    </>

                );

            }

            return (

                <>
                    <FiClock />
                    Pending Review
                </>

            );

        };


    /* ============================
        LOADING
    ============================ */

    if (levelLoading) {

        return (

            <div className="ignite-upload-center">

                <IgniteNavbar />

                <main className="ignite-upload-main">

                    <IgniteHeader

                        title="Upload Centre"

                        subtitle="Upload your challenge videos, stories and sleep tracking to unlock the next level."

                    />

                    <div className="upload-card">

                        Loading Upload Centre...

                    </div>

                </main>

            </div>

        );

    }


    return (

        <>

            <div className="ignite-upload-center">

                <IgniteNavbar />

                <main className="ignite-upload-main">

                    <IgniteHeader

                        title="Upload Centre"

                        subtitle="Upload your challenge videos, stories and sleep tracking to unlock the next level."

                    />


                    {/* =====================================
                        LEVEL INFO
                    ===================================== */}

                    <div className="upload-level-banner">

                        <div>

                            <span>
                                CURRENT LEVEL
                            </span>

                            <strong>
                                Level {currentLevel}
                            </strong>

                        </div>

                        <p>

                            {currentLevel < 3

                                ? "Complete Level 2 to unlock Hammer and Story uploads."

                                : currentLevel < 4

                                    ? "Hammer and Story uploads are unlocked. Complete Level 3 to unlock Sleep Tracking."

                                    : "All Upload Centre challenges are unlocked."

                            }

                        </p>

                    </div>


                    {/* =====================================
                        HAMMER
                    ===================================== */}

                    <div
                        className={
                            `upload-card ${
                                !hammerUnlocked
                                    ? "upload-card-locked"
                                    : ""
                            }`
                        }
                    >

                        <div className="card-top">

                            <div>

                                <h2>
                                    🔥 Hammer 150 Challenge
                                </h2>

                                <p>
                                    Upload your Hammer challenge video.
                                </p>

                            </div>

                            {!hammerUnlocked ? (

                                <span className="status locked">
                                    <FiLock />
                                    Locked
                                </span>

                            ) : (

                                <span
                                    className={
                                        `status ${status.hammer}`
                                    }
                                >
                                    {renderStatus("hammer")}
                                </span>

                            )}

                        </div>


                        {!hammerUnlocked ? (

                            <div className="upload-locked-message">

                                <FiLock size={28} />

                                <strong>
                                    Level 2 Required
                                </strong>

                                <p>
                                    Complete all Level 2 objectives to unlock this upload.
                                </p>

                            </div>

                        ) : (

                            <>

                                <input
                                    id="hammerVideo"
                                    type="file"
                                    accept="video/*"
                                    hidden
                                    onChange={chooseHammer}
                                />

                                <div
                                    className="drop-zone"
                                    onClick={() =>
                                        document
                                            .getElementById(
                                                "hammerVideo"
                                            )
                                            .click()
                                    }
                                >

                                    {hammerPreview ? (

                                        <video
                                            src={hammerPreview}
                                            controls
                                            className="preview-video"
                                        />

                                    ) : (

                                        <>

                                            <FiVideo size={50} />

                                            <h3>
                                                Drag & Drop Video
                                            </h3>

                                            <p>
                                                or Click to Browse
                                            </p>

                                        </>

                                    )}

                                </div>


                                <button

                                    className="upload-btn"

                                    disabled={
                                        hammerUploading ||
                                        !hammerFile
                                    }

                                    onClick={
                                        uploadHammer
                                    }

                                >

                                    <FiUploadCloud />

                                    {
                                        hammerUploading
                                            ? "Uploading..."
                                            : "Upload Video"
                                    }

                                </button>


                                {hammerUploading && (

                                    <div className="progress-container">

                                        <div
                                            className="progress-fill"
                                            style={{
                                                width:
                                                    `${hammerProgress}%`
                                            }}
                                        />

                                        <span>
                                            {hammerProgress}%
                                        </span>

                                    </div>

                                )}

                            </>

                        )}

                    </div>


                    {/* =====================================
                        NON-DOMINANT HAMMER
                    ===================================== */}

                    <div
                        className={
                            `upload-card ${
                                !hammerUnlocked
                                    ? "upload-card-locked"
                                    : ""
                            }`
                        }
                    >

                        <div className="card-top">

                            <div>

                                <h2>
                                    🔥 Hammer 150 — Non-Dominant Hand
                                </h2>

                                <p>
                                    Upload your non-dominant hand Hammer challenge video.
                                </p>

                            </div>

                            {!hammerUnlocked ? (

                                <span className="status locked">
                                    <FiLock />
                                    Locked
                                </span>

                            ) : (

                                <span
                                    className={
                                        `status ${status.nonDominantHammer}`
                                    }
                                >
                                    {renderStatus(
                                        "nonDominantHammer"
                                    )}
                                </span>

                            )}

                        </div>


                        {!hammerUnlocked ? (

                            <div className="upload-locked-message">

                                <FiLock size={28} />

                                <strong>
                                    Level 2 Required
                                </strong>

                                <p>
                                    Complete all Level 2 objectives to unlock this upload.
                                </p>

                            </div>

                        ) : (

                            <>

                                <input
                                    id="nonDominantHammerVideo"
                                    type="file"
                                    accept="video/*"
                                    hidden
                                    onChange={
                                        chooseNonDominantHammer
                                    }
                                />


                                <div
                                    className="drop-zone"
                                    onClick={() =>
                                        document
                                            .getElementById(
                                                "nonDominantHammerVideo"
                                            )
                                            .click()
                                    }
                                >

                                    {nonDominantHammerPreview ? (

                                        <video
                                            src={
                                                nonDominantHammerPreview
                                            }
                                            controls
                                            className="preview-video"
                                        />

                                    ) : (

                                        <>

                                            <FiVideo size={50} />

                                            <h3>
                                                Upload Non-Dominant Hand Video
                                            </h3>

                                            <p>
                                                Click to Browse
                                            </p>

                                        </>

                                    )}

                                </div>


                                <button

                                    className="upload-btn"

                                    disabled={
                                        nonDominantHammerUploading ||
                                        !nonDominantHammerFile
                                    }

                                    onClick={
                                        uploadNonDominantHammer
                                    }

                                >

                                    <FiUploadCloud />

                                    {
                                        nonDominantHammerUploading
                                            ? "Uploading..."
                                            : "Upload Video"
                                    }

                                </button>


                                {nonDominantHammerUploading && (

                                    <div className="progress-container">

                                        <div
                                            className="progress-fill"
                                            style={{
                                                width:
                                                    `${nonDominantHammerProgress}%`
                                            }}
                                        />

                                        <span>
                                            {
                                                nonDominantHammerProgress
                                            }%
                                        </span>

                                    </div>

                                )}

                            </>

                        )}

                    </div>


                    {/* =====================================
                        STORY
                    ===================================== */}

                    <div
                        className={
                            `upload-card ${
                                !storyUnlocked
                                    ? "upload-card-locked"
                                    : ""
                            }`
                        }
                    >

                        <div className="card-top">

                            <div>

                                <h2>
                                    📖 Real Life Story
                                </h2>

                                <p>
                                    Share your inspiring journey.
                                </p>

                            </div>

                            {!storyUnlocked ? (

                                <span className="status locked">
                                    <FiLock />
                                    Locked
                                </span>

                            ) : (

                                <span
                                    className={
                                        `status ${status.story}`
                                    }
                                >
                                    {renderStatus("story")}
                                </span>

                            )}

                        </div>


                        {!storyUnlocked ? (

                            <div className="upload-locked-message">

                                <FiLock size={28} />

                                <strong>
                                    Level 2 Required
                                </strong>

                                <p>
                                    Complete all Level 2 objectives to unlock this upload.
                                </p>

                            </div>

                        ) : (

                            <>

                                <input
                                    id="storyVideo"
                                    type="file"
                                    accept="video/*"
                                    hidden
                                    onChange={chooseStory}
                                />


                                <div
                                    className="drop-zone"
                                    onClick={() =>
                                        document
                                            .getElementById(
                                                "storyVideo"
                                            )
                                            .click()
                                    }
                                >

                                    {storyPreview ? (

                                        <video
                                            src={
                                                storyPreview
                                            }
                                            controls
                                            className="preview-video"
                                        />

                                    ) : (

                                        <>

                                            <FiVideo size={50} />

                                            <h3>
                                                Upload Story Video
                                            </h3>

                                            <p>
                                                MP4 • MOV • AVI
                                            </p>

                                        </>

                                    )}

                                </div>


                                <button

                                    className="upload-btn"

                                    disabled={
                                        storyUploading ||
                                        !storyFile
                                    }

                                    onClick={
                                        uploadStory
                                    }

                                >

                                    <FiUploadCloud />

                                    {
                                        storyUploading
                                            ? "Uploading..."
                                            : "Upload Story"
                                    }

                                </button>


                                {storyUploading && (

                                    <div className="progress-container">

                                        <div
                                            className="progress-fill"
                                            style={{
                                                width:
                                                    `${storyProgress}%`
                                            }}
                                        />

                                        <span>
                                            {storyProgress}%
                                        </span>

                                    </div>

                                )}

                            </>

                        )}

                    </div>


                    {/* =====================================
                        SLEEP TRACKING
                    ===================================== */}

                    <div
                        className={
                            `upload-card ${
                                !sleepUnlocked
                                    ? "upload-card-locked"
                                    : ""
                            }`
                        }
                    >

                        <div className="card-top">

                            <div>

                                <h2>
                                    😴 Sleep Tracking
                                </h2>

                                <p>
                                    Upload today's sleep screenshot.
                                </p>

                            </div>

                            {!sleepUnlocked ? (

                                <span className="status locked">
                                    <FiLock />
                                    Locked
                                </span>

                            ) : (

                                <span
                                    className={
                                        `status ${status.sleep}`
                                    }
                                >
                                    {renderStatus("sleep")}
                                </span>

                            )}

                        </div>


                        {!sleepUnlocked ? (

                            <div className="upload-locked-message">

                                <FiLock size={28} />

                                <strong>
                                    Level 3 Required
                                </strong>

                                <p>
                                    Complete all Level 3 objectives to unlock Sleep Tracking.
                                </p>

                            </div>

                        ) : (

                            <>

                                <div className="today-upload">

                                    <div>

                                        <h3>
                                            Today's Upload
                                        </h3>

                                        <p>
                                            Day{" "}
                                            {sleepDays.length + 1}
                                        </p>

                                    </div>


                                    <input
                                        id="sleepImage"
                                        type="file"
                                        accept="image/*"
                                        hidden
                                        onChange={
                                            chooseSleep
                                        }
                                    />


                                    <button
                                        onClick={() =>
                                            document
                                                .getElementById(
                                                    "sleepImage"
                                                )
                                                .click()
                                        }
                                    >

                                        <FiImage />

                                        Choose Screenshot

                                    </button>

                                </div>


                                {sleepPreview && (

                                    <div className="image-preview">

                                        <img
                                            src={
                                                sleepPreview
                                            }
                                            alt="Sleep"
                                            className="preview-image"
                                        />

                                    </div>

                                )}


                                <button

                                    className="upload-btn"

                                    disabled={
                                        sleepUploading ||
                                        !sleepFile
                                    }

                                    onClick={
                                        uploadSleep
                                    }

                                >

                                    <FiUploadCloud />

                                    {
                                        sleepUploading
                                            ? "Uploading..."
                                            : "Upload Screenshot"
                                    }

                                </button>


                                {sleepUploading && (

                                    <div className="progress-container">

                                        <div
                                            className="progress-fill"
                                            style={{
                                                width:
                                                    `${sleepProgress}%`
                                            }}
                                        />

                                        <span>
                                            {sleepProgress}%
                                        </span>

                                    </div>

                                )}


                                <div className="calendar">

                                    {Array
                                        .from({
                                            length: 30
                                        })
                                        .map(
                                            (_, index) => {

                                                const day =
                                                    index + 1;

                                                let cls =
                                                    "locked";

                                                if (
                                                    sleepDays
                                                        .includes(
                                                            day
                                                        )
                                                ) {

                                                    cls =
                                                        "approved";

                                                }

                                                if (
                                                    day ===
                                                    sleepDays.length +
                                                    1
                                                ) {

                                                    cls =
                                                        "today";

                                                }

                                                return (

                                                    <div
                                                        key={day}
                                                        className={
                                                            `day ${cls}`
                                                        }
                                                    >

                                                        {day}

                                                    </div>

                                                );

                                            }
                                        )}

                                </div>

                            </>

                        )}

                    </div>

                </main>

            </div>

        </>

    );

};


export default UploadCenter;